import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import FinancingApplicationsTableContainer from '../../../modules/financingApplications/components/FinancingApplicationsTableContainer';

const FinancingApplications = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle, searchEle } = useModuleTableHelpers({
    route: 'admin/finance-applications',
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('links.financing_applications'),
    withPagination: true,
    queryKey: 'financing-applications',
    customSearchPlaceholder: `${t("search_by")} ${t("name")} ${t("or")} ${t("code")}`
  });

  const tableHeaders = [
    { label: t('id') },
    { label: t('variant') },
    { label: t('user') },
    { label: t('salary') },
    { label: t('job') },
    { label: t('status') },
    { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="locations-page-container">
      <ListHeader customClass='table_filters'>
        <div className="filter_container">
          {searchEle}
        </div>
      </ListHeader>
      <FinancingApplicationsTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_locations_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default FinancingApplications;
